import { useState, useEffect, useRef, useMemo } from "react"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import Header from "@/routes/_layout/header"
import { langStore } from "@/stores/lang-store"
import useIsMobile from "@/hooks/use-is-mobile"
import useOutsideClick from "@/hooks/use-outside-click"
import Headline from "@/components/headline"
import Wrapper from "@/components/wrapper"
import { SIDO_ORDER } from "@/datas/apartData"
import AptGroupSelector from "./_components/apt-group-selector"
import { aptSelectBundle } from "./apt-select-const"
import ResultView from "./_components/result-view"
import AptGroupManager from "./_components/apt-group-manager"
import AptSearchView from "./_components/apt-search-view"
import { aptGroupStore } from "./_components/apt-group-store"
import { useToggleStore } from "@/hooks/use-toggle-store"

const AptSelectPage = () => {
  const isMobile = useIsMobile()
  const mode = isMobile ? "mobile" : "desktop"

  const RootHeader = Header.default[mode]

  const filterRef = useRef(null)
  const { lang } = langStore()
  const { addrTree } = aptSearchStore()

  const [isOpen, setIsOpen] = useState(false)

  const [aptList, setAptList] = useState([])
  const { show: isEdit, close } = useToggleStore("group-edit-mode")

  const { activeGroupName } = aptGroupStore()
  const { groupAptList, setGroupAptList } = aptGroupStore()

  useOutsideClick({
    ref: filterRef,
    enabled: isOpen,
    onOutside: () => setIsOpen(false)
  })

  // 주소 트리 초기화
  useEffect(() => {
    return () => {
      aptSearchStore.getState().resetSearch()
      aptGroupStore.getState().setGroupAptList([])
      aptGroupStore.getState().setActiveGroupName("")
      close()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const displayAptList = isEdit ? aptList : activeGroupName ? groupAptList : aptList

  const sortedApts = useMemo(() => {
    return [...displayAptList].sort((a, b) => {
      return SIDO_ORDER.indexOf(a.sido_key) - SIDO_ORDER.indexOf(b.sido_key)
    })
  }, [displayAptList])

  return (
    <div className="h-screen bg-slate-50 text-slate-900 overflow-hidden">
      <RootHeader />

      <Wrapper.maxWidth className="pt-4 md:pr-5 h-[calc(100%-60px)] flex flex-col">
        <Headline
          title={aptSelectBundle.header.title[lang]}
          description={aptSelectBundle.header.description[lang]}
        />

        <AptSearchView
          addrTree={addrTree}
          onSearchResults={(result) => {
            setAptList(result)
            setGroupAptList([])
          }}
        />

        <AptGroupSelector />

        <AptGroupManager />
        <div className="mt-8 overflow-y-auto -mr-5 pr-1 [scrollbar-gutter:stable]">
          <ResultView aptList={sortedApts} />
        </div>
      </Wrapper.maxWidth>
    </div>
  )
}

export default AptSelectPage
